/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import BalanceAction from "../action/BalanceAction"

export const initialState = ({
    loading: false,
    transactionList: null, 
    balance: null,    
})

export default function (state = initialState, action) {
  switch (action.type) {

    case BalanceAction.TYPES.REQUEST_BALANCE_TRANSACTION_LIST:
      return Object.assign({}, state, { transactionList: null, loading: true})

    case BalanceAction.TYPES.REQUEST_BALANCE_TRANSACTION_LIST_SUCCESS:
      return Object.assign({}, state, { transactionList: action.payload, loading: false})

    case BalanceAction.TYPES.REQUEST_BALANCE_DETAIL_SUCCESS:
      return Object.assign({}, state, { balance: action.payload.data, loading: false})
    
    default:
      return state
  }
}